import { createContext, useState, useEffect, createElement as h } from 'react';
import { createUppyEventAdapter } from '@uppy/components';
export const UppyContext = createContext({
  uppy: undefined,
  status: 'init',
  progress: 0
});
export function UppyContextProvider(_ref) {
  let {
    uppy,
    children
  } = _ref;
  const [status, setStatus] = useState('init');
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (!uppy) {
      throw new Error('UppyContextProvider: passing `uppy` as a prop is required');
    }
    const uppyEventAdapter = createUppyEventAdapter({
      uppy,
      onStatusChange: newStatus => {
        setStatus(newStatus);
      },
      onProgressChange: newProgress => {
        setProgress(newProgress);
      }
    });
    return () => uppyEventAdapter.cleanup();
  }, [uppy]);
  return h(UppyContext.Provider, {
    value: {
      uppy,
      status,
      progress
    }
  }, children);
}
export default UppyContextProvider;